import {
  WSElement,
  WSFlexBox,
  WSPanel,
  WSSectionToolbar,
  WSText
} from "@wingspanhq/fe-component-library";
import { queriesPayees } from "@query";

import { useInternalNotesModal } from "../InternalNotesModal/useInternalNotesModal";
import { useXWingspanPayerId } from "../../routes/RoutePayeeDetails/useXWingspanPayerId";

type Props = {
  payeeId: string;
};

export const InternalNotesWidget: React.FC<Props> = ({ payeeId }) => {
  const modalInternalNotes = useInternalNotesModal();
  const xWingspanAccount = useXWingspanPayerId();
  const queryPayee = queriesPayees.getPayee.useQuery({
    payeeId,
    xWingspanAccount
  });

  const internalNotes = queryPayee.data?.internalNotes;

  // TODO(v3): gap — the "last edited by/at" byline (v1
  // eventActors.internalNotesUpdatedBy / events.internalNotesUpdatedAt) has no
  // v3 source; PayeeEvents only carries created/updated/de/activated timestamps.

  return internalNotes ? (
    <WSElement>
      <WSSectionToolbar
        mb="S"
        title="Internal notes"
        button={{
          label: "Edit",
          onClick: () => {
            modalInternalNotes.open({
              payeeId,
              internalNotes
            });
          }
        }}
      />
      <WSPanel>
        <WSFlexBox direction="column" gap="XL">
          <WSFlexBox direction="column" gap="S" alignItems="stretch">
            <WSText.ParagraphSm color="gray500" singleLine>
              Notes
            </WSText.ParagraphSm>
            <WSText.ParagraphSm color="gray700">
              {internalNotes}
            </WSText.ParagraphSm>
          </WSFlexBox>
        </WSFlexBox>
      </WSPanel>
    </WSElement>
  ) : null;
};
